import { useEffect, useRef, useState } from 'preact/hooks';
import { RefObject } from 'preact';

export const useHoverRef = (ref?: RefObject<HTMLDivElement | HTMLAnchorElement>): Array<any> => {
  const [hovered, setHovered] = useState(false);
  const refObject = ref || useRef(null);
  const onMouseEnter = (): void => setHovered(true);
  const onMouseLeave = (): void => setHovered(false);
  useEffect(
    () => {
      const node = refObject.current;
      if (node) {
        node.addEventListener('mouseenter', onMouseEnter);
        node.addEventListener('mouseleave', onMouseLeave);
      }
      return (): void => {
        if (node) {
          node.removeEventListener('mouseenter', onMouseEnter);
          node.removeEventListener('mouseleave', onMouseLeave);
        }
      };
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [refObject.current]
  );
  return ref ? [hovered] : [refObject, hovered];
};
